import React from "react";

import AxisComparatorCarriageSection from "./AxisComparatorCarriageSection";

const AxisComparatorCarriagesComparatorSelection = ({ compareDatas, ...props }) => {
  var maxCarriageNumber = compareDatas?.reduce((max, bundle) => {
    const maxValue = max ?? 0;
    var l = bundle.calculations?.precalcKFactorCarriage.length;
    if (l >= maxValue) {
      return l;
    }
    return max;
  }, 0);

  const carriages = [];
  for (var carriageNumber = 0; carriageNumber < maxCarriageNumber; carriageNumber++) {
    carriages.push(
      <AxisComparatorCarriageSection
        dataset-id={`axis-comparator-carriage-${carriageNumber + 1}-section`}
        carriageNumber={carriageNumber}
        compareDatas={compareDatas}
        {...props}
      />
    );
  }

  return <div className="AxisComparatorCarriageComparatorSelection">{carriages}</div>;
};

export default AxisComparatorCarriagesComparatorSelection;
